import * as Yup from 'yup';
import { FormFields, ValidationSchema } from '@/data/Types';

export const formFieldsInitialValues = (formFields: FormFields): Record<string, string> => {
    const initialValues: { [key: string]: string } = {};

    for (const [key, value] of Object.entries(formFields)) {
        initialValues[key] = value.initialValue;
    }
    return initialValues;
};

const formFieldsValidation = (formFields: FormFields): Record<string, ValidationSchema<string>> => {
    const validation: { [key: string]: ValidationSchema<string> } = {};

    for (const [key, value] of Object.entries(formFields)) {
        validation[key] = value.validation;
    }
    return validation;
};

export const formFieldsValidationSchema = (formFields: FormFields) =>
    Yup.object().shape(formFieldsValidation(formFields));

export const requiredFormFields = (formFields: FormFields) => {
    const required: { [key: string]: boolean } = {};

    for (const [key, value] of Object.entries(formFields)) {
        if (value.required) {
            required[key] = value.required;
        }
    }
    return required;
};

export const requiredFieldsMissing = (formFields: FormFields, errors: string[]): boolean => {
    const requiredFields = Object.keys(requiredFormFields(formFields));
    const missingFields = errors.filter((errorField) => requiredFields.includes(errorField));
    return !!missingFields.length;
};
